import React from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { useUser } from 'hooks/use-user.hook';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { BackLink } from 'components/back-link';
import { StandardRow } from 'components/standard-row';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import { Page } from 'styles';
import { Footer } from 'pages/settings/settings.style';
import { CCPAButton } from './ccpa-link';

const getCopy = copyFor('settings.personalInformation');
const { editLogin, name, settings, smsPreference } = routes();

export const PersonalInformation = () => {
  const { data: user, loading, error } = useUser();

  if (loading) return <LoadingPage numberOfSections={2} />;
  if (error || !user) {
    return <ErrorPage title={getCopy('title')} to={settings} />;
  }

  const { enabledGoogleSignIn } = user.preferences;

  return (
    <>
      <BackLink to={settings} />
      <Page maxWidth={MAX_SECONDARY_PAGE_WIDTH}>
        <Text textStyle="heading800" tag="h1" margin={{ bottom: '48px' }}>
          {getCopy('title')}
        </Text>
        <StandardRow
          heading={getCopy('nameLabel')}
          text={user.name}
          iconLinkProps={{
            margin: '0px',
            to: name,
          }}
          notranslate={true}
        />
        <StandardRow
          heading={getCopy('editLoginLabel')}
          text={user.email}
          iconLinkProps={{
            margin: '0px',
            to: editLogin,
          }}
          notranslate={true}
        />
        <StandardRow
          heading={getCopy('smsPreference.label')}
          text={getCopy('smsPreference.subHeader')}
          hasBottomBorder={!enabledGoogleSignIn}
          iconLinkProps={{
            margin: '0px',
            to: smsPreference,
          }}
        />
        {enabledGoogleSignIn && (
          <StandardRow
            hasBottomBorder={true}
            heading={getCopy('googleSignIn.label')}
            text={getCopy('googleSignIn.enabled')}
          />
        )}
        <Footer>
          <CCPAButton />
        </Footer>
      </Page>
    </>
  );
};
